import React, { useCallback } from 'react';
import { Header } from 'common/components/Header';
import { FormikOnSubmit } from 'lib/formik.utils';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { message } from 'antd';
import { useEnsureContext } from 'common/hooks';
import { useHistory } from 'react-router';
import {
  BusinessPartnerRegisterProfileOwner,
  BusinessPartnerRegisterProfileOwnerForm,
} from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerRegisterProfileOwnerPage/BusinessPartnerRegisterProfileOwnerForm';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerRoutes } from 'pages/BusinessPartnerManagement/businessPartnerRoutes';

export const BusinessPartnerRegisterProfileOwnerPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const queryCache = useQueryCache();
  const intlMessage = useFormatMessage();

  const [mutate, { isLoading }] = useMutation(
    BusinessPartnersAPI.registerNewUser
  );

  const history = useHistory();

  const handleSubmit: FormikOnSubmit<BusinessPartnerRegisterProfileOwner> = useCallback(
    (formData, { resetForm }) => {
      const formDataToSend = formData;

      mutate(
        {
          businessPartnerId: formDataToSend.partner
            ? formDataToSend.partner
            : bpContext.id,
          dto: formDataToSend,
        },
        {
          onSuccess: () => {
            resetForm();
            queryCache
              .invalidateQueries(QueryKey.BusinessPartnerProfileOwnersList)
              .then();
            message.success(
              intlMessage(
                { id: 'familyUsers.register.success' },
                {
                  firstName: formData.firstName,
                  lastName: formData.lastName,
                }
              )
            );
            history.push(`../${BusinessPartnerRoutes.FamilyUsers}`);
          },
        }
      ).then();
    },
    [bpContext, mutate, queryCache, intlMessage, history]
  );

  return (
    <>
      <Header title={intlMessage({ id: 'users.new' })} />
      <BusinessPartnerRegisterProfileOwnerForm
        onSubmit={handleSubmit}
        loading={isLoading}
      />
    </>
  );
};
